import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import CondicionIngreso from '../../../../../Calado/containers/CondicionIngreso'
import * as actions from '../actions/TablaCamionesCaladosActions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_PROCESO_CALADO } from '../../../../../../config/forms'
import NumPad from 'react-numpad'
import CaladoSwitch from '../../../../../Calado/containers/CaladoSwitch'
import { CircularProgress } from '@material-ui/core'
import { INTERVALO_CORTO } from '../../../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import CalleGrande from '../../../../../Calado/containers/CalleGrande'
import { cerealesColor } from '../../../../../../config/cereales'

class DialogoCaladoUpdate extends Component {
  constructor (props) {
    super(props)
    this.handleCondicionChange = this.handleCondicionChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.consultaEstadoOcupacionCalles = this.consultaEstadoOcupacionCalles.bind(this)
    this.consultaCalificacionPorCalle = this.consultaCalificacionPorCalle.bind(this)
  }

  componentDidMount () {
    const { numero } = this.props
    this.props.getConsultaCea(numero)
    this.props.requestDatosConsultaCpa(numero)
    this.props.updateFumigado(false)
    this.props.updateSiloAparte(false)
    this.props.updatePendienteAutorizar(false)
    this.consultaEstadoOcupacionCalles()
    this.consultaCalificacionPorCalle()
  }

  componentWillUnmount () {
    this.props.updateHumedad(0)
    this.props.updateFumigado(false)
    this.props.updateSiloAparte(false)
    this.props.updatePendienteAutorizar(false)
    this.props.change('condicionIngreso', null)
    this.props.change('condicionIngresoSegunda', null)
  }

  componentDidUpdate () {
    const { cea, humedad, modoIngreso, change: formChange } = this.props
    if (cea && cea.humedad && humedad === 0) {
      this.props.change('modoIngreso', cea.estadoCalificacion)
      if (modoIngreso !== 'A') {
        this.props.change('condicionIngreso', cea.claveCalificacionCereal)
        this.props.setModo(cea.claveCereal, cea.estadoCalificacion)
      }
      this.props.updateHumedad(cea.humedad * 10)
      this.props.updateFumigado(cea.fumigado)
      this.props.updateSiloAparte(!cea.caravana)
      this.props.updatePendienteAutorizar(cea.rechazoAdministrativoCalado === 'P')
      formChange('calle', cea.calleDeCalado)
    }
  }

  consultaCalificacionPorCalle () {
    this.props.consultaCalificacionPorCalle()
  }

  consultaEstadoOcupacionCalles () {
    this.props.consultaEstadoOcupacionCalles()
  }

  handleCondicionChange (modo) {
    if (modo === 'A') {
      this.props.change('condicionIngreso', null)
      this.props.change('condicionIngresoSegunda', null)
    }
  }

  handleChange (humedad) {
    if (humedad < 300 && humedad > 100) {
      this.props.updateHumedad(humedad)
    }
  }

  render () {
    const {
      cea,
      cpa,
      numero,
      humedad,
      pendienteAutorizar,
      estadoOcupacionCallesCalado,
      calificacionCalles
    } = this.props

    var data = []
    const generarData = (estadoOcupacionCallesCalado) => {
      estadoOcupacionCallesCalado.filas.forEach((calle) => {
        data.push([
          `C${calle.calleDeCalado}`,
          calle.ocupado,
          (calle.cerealAsignado != null) ? cerealesColor[`${calle.cerealAsignado.trim()}`] : '#e0e0e0',
          `${calle.capacidad}`,
          `${calle.cerealAsignado}`,
          `Calle ${calle.calleDeCalado}-Capacidad ${calle.capacidad}-Usado ${calle.ocupado}-Cereal ${calle.cerealAsignado}`,
          calle.ordenDeSalida
        ])
      })
    }
    if (estadoOcupacionCallesCalado !== null && estadoOcupacionCallesCalado.filas_procesadas > 0) {
      if (estadoOcupacionCallesCalado.estado === 'exito') {
        generarData(estadoOcupacionCallesCalado)
      }
    }

    return (
      <div>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <Card style={{ border: 'none' }}>
          {!cea && <div style={{ padding: '10% 0', margin: '0 auto' }} >
            <CircularProgress />
          </div> }
          {cea && <Card.Body>
            <h4 style={{ textAlign: 'center' }}> <strong>{cea.cereal}</strong></h4>
            <h3 style={{ textAlign: 'center' }} >Número de CTG: <strong>{numero}</strong></h3>
            <div style={{ marginTop: '5%' }} >
              <CondicionIngreso onChange={this.handleCondicionChange} />
            </div>
            <div className='flex-nowrap container-condicion-recalado' >
              <CaladoSwitch disabledPendienteAutorizar={pendienteAutorizar} />
              {humedad && <div className='box-humedad-edicion'>
                <h4>Humedad</h4>
                <Card style={{ backgroundColor: '#ffffff', color: '#495057' }}>
                  <NumPad.Number
                    className='numpad'
                    onChange={(humedad) => {
                      console.log('Humedad', humedad)
                      this.handleChange(humedad)
                    }}
                    position='center'
                    decimal={false}
                    negative={false}
                  >
                    <h3>{humedad}</h3>
                  </NumPad.Number>
                </Card>
              </div>}
              <div style={{ textAlign: 'center' }}>
                <CalleGrande style={{ margin: '0 auto' }} data={data} cpa={cpa} calificacionCalles={calificacionCalles} />
              </div>
            </div>
          </Card.Body> }
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    cea: state.calado.consultaCea,
    cpa: state.calado.cpa,
    modoIngreso: (state.calado.consultaCea) ? state.calado.consultaCea.estadoCalificacion : 'A',
    humedad: state.calado.humedad,
    pendienteAutorizar: state.calado.pendienteAutorizar,
    estadoOcupacionCallesCalado: state.calado.estadoOcupacionCallesCalado,
    calificacionCalles: state.calado.calificacionPorCalleCalado
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCaladoUpdate))
